module.exports = "/_next/static/images/AiAdoptionGraph-0dc77f3c092b7f4862ac896b74a37a64.webp";